import jsPDF from 'jspdf';

const COLORS = {
  teal: [20, 184, 166],
  stone900: [28, 25, 23],
  stone600: [87, 83, 78],
  stone400: [168, 162, 158],
  white: [255, 255, 255],
  amber: [245, 158, 11],
  pink: [236, 72, 153],
  blue: [59, 130, 246],
  green: [34, 197, 94]
};

// Translations for PDF content
const pdfTranslations = {
  en: {
    title: "Puglia Pocket Guide",
    subtitle: "Your essential travel companion",
    culturalTips: "Cultural Tips",
    etiquette: "Local Etiquette",
    dressCode: "Dress Code",
    tippingGuide: "Tipping Guide",
    emergencyContacts: "Emergency Contacts",
    usefulPhrases: "Useful Italian Phrases",
    recommendedPlaces: "Recommended Places",
    beaches: "Top Beaches",
    events: "Upcoming Events",
    generatedBy: "Generated by OspitAI",
    greetings: "Greetings: Kiss on both cheeks (start left). Handshake for first meetings.",
    dining: "Dining: Lunch 1-3pm (many shops close). Dinner after 8pm.",
    churches: "Churches: Cover shoulders and knees when visiting.",
    siesta: "Siesta: Respect riposo 1-4pm. Many businesses close.",
    beachDress: "Beach: Beach attire only at the beach. Cover up in towns.",
    restaurantDress: "Restaurants: Smart casual. No shorts at upscale venues.",
    passeggiata: "Evening: Join the passeggiata (stroll) dressed elegantly 7-9pm.",
    tipRestaurant: "Restaurants: Coperto (€1-3) usually included. Round up if satisfied.",
    tipBar: "Bars: Tipping not expected. €0.50-1 for table service.",
    tipTour: "Tours: €5-10 per person for excellent guides.",
    emergency: "Emergency: 112 (works without SIM)",
    police: "Police: 113",
    ambulance: "Ambulance: 118",
    hello: "Hello: Buongiorno (formal) / Ciao (informal)",
    thanks: "Thank you: Grazie",
    please: "Please: Per favore",
    sorry: "Sorry: Mi scusi / Scusa",
    howMuch: "How much: Quanto costa?",
    bill: "The bill please: Il conto, per favore",
    delicious: "Delicious: Delizioso!",
    beautiful: "Beautiful: Bellissimo!"
  },
  it: {
    title: "Guida Tascabile della Puglia",
    subtitle: "Il tuo compagno di viaggio essenziale",
    culturalTips: "Consigli Culturali",
    etiquette: "Etichetta Locale",
    dressCode: "Codice di Abbigliamento",
    tippingGuide: "Guida alle Mance",
    emergencyContacts: "Contatti di Emergenza",
    usefulPhrases: "Frasi Utili in Italiano",
    recommendedPlaces: "Luoghi Consigliati",
    beaches: "Migliori Spiagge",
    events: "Prossimi Eventi",
    generatedBy: "Generato da OspitAI",
    greetings: "Saluti: Bacio su entrambe le guance (inizia da sinistra). Stretta di mano per i primi incontri.",
    dining: "Pranzo: 13-15 (molti negozi chiudono). Cena dopo le 20.",
    churches: "Chiese: Copri spalle e ginocchia quando visiti.",
    siesta: "Riposo: Rispetta il riposo 13-16. Molte attività chiudono.",
    beachDress: "Spiaggia: Abbigliamento da spiaggia solo in spiaggia. Copriti in paese.",
    restaurantDress: "Ristoranti: Smart casual. Niente shorts nei locali eleganti.",
    passeggiata: "Sera: Unisciti alla passeggiata vestito elegante 19-21.",
    tipRestaurant: "Ristoranti: Coperto (€1-3) solitamente incluso. Arrotonda se soddisfatto.",
    tipBar: "Bar: Mancia non prevista. €0,50-1 per servizio al tavolo.",
    tipTour: "Tour: €5-10 a persona per guide eccellenti.",
    emergency: "Emergenza: 112 (funziona senza SIM)",
    police: "Polizia: 113",
    ambulance: "Ambulanza: 118",
    hello: "Ciao: Buongiorno (formale) / Ciao (informale)",
    thanks: "Grazie",
    please: "Per favore",
    sorry: "Mi scusi / Scusa",
    howMuch: "Quanto costa?",
    bill: "Il conto, per favore",
    delicious: "Delizioso!",
    beautiful: "Bellissimo!"
  },
  es: {
    title: "Guía de Bolsillo de Puglia",
    subtitle: "Tu compañero de viaje esencial",
    culturalTips: "Consejos Culturales",
    etiquette: "Etiqueta Local",
    dressCode: "Código de Vestimenta",
    tippingGuide: "Guía de Propinas",
    emergencyContacts: "Contactos de Emergencia",
    usefulPhrases: "Frases Útiles en Italiano",
    recommendedPlaces: "Lugares Recomendados",
    beaches: "Mejores Playas",
    events: "Próximos Eventos",
    generatedBy: "Generado por OspitAI",
    greetings: "Saludos: Beso en ambas mejillas (empieza izquierda). Apretón de manos para primeros encuentros.",
    dining: "Comidas: Almuerzo 13-15h (muchas tiendas cierran). Cena después de 20h.",
    churches: "Iglesias: Cubre hombros y rodillas al visitar.",
    siesta: "Siesta: Respeta el riposo 13-16h. Muchos negocios cierran.",
    beachDress: "Playa: Ropa de playa solo en la playa. Cúbrete en pueblos.",
    restaurantDress: "Restaurantes: Smart casual. Nada de shorts en locales elegantes.",
    passeggiata: "Noche: Únete a la passeggiata vestido elegante 19-21h.",
    tipRestaurant: "Restaurantes: Coperto (€1-3) normalmente incluido. Redondea si satisfecho.",
    tipBar: "Bares: No se espera propina. €0,50-1 por servicio en mesa.",
    tipTour: "Tours: €5-10 por persona para guías excelentes.",
    emergency: "Emergencia: 112 (funciona sin SIM)",
    police: "Policía: 113",
    ambulance: "Ambulancia: 118",
    hello: "Hola: Buongiorno (formal) / Ciao (informal)",
    thanks: "Gracias: Grazie",
    please: "Por favor: Per favore",
    sorry: "Perdón: Mi scusi / Scusa",
    howMuch: "Cuánto cuesta: Quanto costa?",
    bill: "La cuenta por favor: Il conto, per favore",
    delicious: "Delicioso: Delizioso!",
    beautiful: "Hermoso: Bellissimo!"
  },
  fr: {
    title: "Guide de Poche des Pouilles",
    subtitle: "Votre compagnon de voyage essentiel",
    culturalTips: "Conseils Culturels",
    etiquette: "Étiquette Locale",
    dressCode: "Code Vestimentaire",
    tippingGuide: "Guide des Pourboires",
    emergencyContacts: "Contacts d'Urgence",
    usefulPhrases: "Phrases Utiles en Italien",
    recommendedPlaces: "Lieux Recommandés",
    beaches: "Meilleures Plages",
    events: "Événements à Venir",
    generatedBy: "Généré par OspitAI",
    greetings: "Salutations: Bisous sur les deux joues (commencez à gauche). Poignée de main pour premières rencontres.",
    dining: "Repas: Déjeuner 13-15h (beaucoup de magasins ferment). Dîner après 20h.",
    churches: "Églises: Couvrez épaules et genoux lors des visites.",
    siesta: "Sieste: Respectez le riposo 13-16h. Beaucoup de commerces ferment.",
    beachDress: "Plage: Tenue de plage uniquement à la plage. Couvrez-vous en ville.",
    restaurantDress: "Restaurants: Smart casual. Pas de shorts dans les établissements chics.",
    passeggiata: "Soir: Rejoignez la passeggiata habillé élégamment 19-21h.",
    tipRestaurant: "Restaurants: Coperto (€1-3) généralement inclus. Arrondissez si satisfait.",
    tipBar: "Bars: Pourboire non attendu. €0,50-1 pour service à table.",
    tipTour: "Visites: €5-10 par personne pour d'excellents guides.",
    emergency: "Urgence: 112 (fonctionne sans SIM)",
    police: "Police: 113",
    ambulance: "Ambulance: 118",
    hello: "Bonjour: Buongiorno (formel) / Ciao (informel)",
    thanks: "Merci: Grazie",
    please: "S'il vous plaît: Per favore",
    sorry: "Désolé: Mi scusi / Scusa",
    howMuch: "Combien: Quanto costa?",
    bill: "L'addition svp: Il conto, per favore",
    delicious: "Délicieux: Delizioso!",
    beautiful: "Magnifique: Bellissimo!"
  },
  de: {
    title: "Apulien Taschenführer",
    subtitle: "Ihr unverzichtbarer Reisebegleiter",
    culturalTips: "Kulturelle Tipps",
    etiquette: "Lokale Etikette",
    dressCode: "Kleiderordnung",
    tippingGuide: "Trinkgeld-Guide",
    emergencyContacts: "Notfallkontakte",
    usefulPhrases: "Nützliche Italienische Phrasen",
    recommendedPlaces: "Empfohlene Orte",
    beaches: "Beste Strände",
    events: "Kommende Veranstaltungen",
    generatedBy: "Erstellt von OspitAI",
    greetings: "Begrüßung: Kuss auf beide Wangen (links beginnen). Händedruck bei ersten Treffen.",
    dining: "Essen: Mittagessen 13-15 Uhr (viele Geschäfte geschlossen). Abendessen nach 20 Uhr.",
    churches: "Kirchen: Schultern und Knie bedecken beim Besuch.",
    siesta: "Siesta: Respektieren Sie die Ruhezeit 13-16 Uhr. Viele Geschäfte geschlossen.",
    beachDress: "Strand: Strandkleidung nur am Strand. In Städten bedecken.",
    restaurantDress: "Restaurants: Smart casual. Keine Shorts in gehobenen Lokalen.",
    passeggiata: "Abend: Schließen Sie sich der Passeggiata elegant gekleidet 19-21 Uhr an.",
    tipRestaurant: "Restaurants: Coperto (€1-3) normalerweise inklusive. Bei Zufriedenheit aufrunden.",
    tipBar: "Bars: Trinkgeld nicht erwartet. €0,50-1 für Tischservice.",
    tipTour: "Touren: €5-10 pro Person für ausgezeichnete Guides.",
    emergency: "Notfall: 112 (funktioniert ohne SIM)",
    police: "Polizei: 113",
    ambulance: "Krankenwagen: 118",
    hello: "Hallo: Buongiorno (formal) / Ciao (informal)",
    thanks: "Danke: Grazie",
    please: "Bitte: Per favore",
    sorry: "Entschuldigung: Mi scusi / Scusa",
    howMuch: "Wie viel: Quanto costa?",
    bill: "Die Rechnung bitte: Il conto, per favore",
    delicious: "Köstlich: Delizioso!",
    beautiful: "Wunderschön: Bellissimo!"
  }
};

export const generatePocketGuide = async (language = 'en', location = 'Monopoli', beaches = [], events = []) => {
  const t = pdfTranslations[language] || pdfTranslations.en;
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const margin = 15;
  let y = margin;

  // Helper function for colored rectangles
  const drawRect = (x, yPos, width, height, color) => {
    doc.setFillColor(...color);
    doc.rect(x, yPos, width, height, 'F');
  };

  // Helper for section headers
  const drawSectionHeader = (text, iconColor = COLORS.teal) => {
    if (y > pageHeight - 40) {
      doc.addPage();
      y = margin;
    }
    drawRect(margin, y, pageWidth - 2 * margin, 10, iconColor);
    doc.setTextColor(...COLORS.white);
    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.text(text, margin + 5, y + 7);
    doc.setTextColor(...COLORS.stone900);
    y += 15;
  };

  // Helper for bullet points
  const addBullet = (text, indent = 0) => {
    if (y > pageHeight - 15) {
      doc.addPage();
      y = margin;
    }
    doc.setFontSize(9);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(...COLORS.stone600);
    
    const lines = doc.splitTextToSize(text, pageWidth - 2 * margin - indent - 10);
    doc.text('•', margin + indent, y);
    doc.text(lines, margin + indent + 5, y);
    y += lines.length * 5 + 2;
  };

  // ============= COVER PAGE =============
  drawRect(0, 0, pageWidth, 80, COLORS.teal);
  
  doc.setTextColor(...COLORS.white);
  doc.setFontSize(28);
  doc.setFont('helvetica', 'bold');
  doc.text(t.title, pageWidth / 2, 35, { align: 'center' });
  
  doc.setFontSize(14);
  doc.setFont('helvetica', 'normal');
  doc.text(t.subtitle, pageWidth / 2, 50, { align: 'center' });
  
  doc.setFontSize(12);
  doc.text(location, pageWidth / 2, 65, { align: 'center' });
  
  y = 95;
  
  // ============= CULTURAL TIPS =============
  doc.setTextColor(...COLORS.stone900);
  doc.setFontSize(16);
  doc.setFont('helvetica', 'bold');
  doc.text(t.culturalTips, margin, y);
  y += 12;

  // Etiquette
  drawSectionHeader(t.etiquette, COLORS.pink);
  addBullet(t.greetings);
  addBullet(t.dining);
  addBullet(t.churches);
  addBullet(t.siesta);
  y += 5;

  // Dress Code
  drawSectionHeader(t.dressCode, COLORS.blue);
  addBullet(t.beachDress);
  addBullet(t.restaurantDress);
  addBullet(t.passeggiata);
  y += 5;

  // Tipping
  drawSectionHeader(t.tippingGuide, COLORS.green);
  addBullet(t.tipRestaurant);
  addBullet(t.tipBar);
  addBullet(t.tipTour);
  y += 10;

  // ============= EMERGENCY CONTACTS =============
  doc.addPage();
  y = margin;
  
  drawSectionHeader(t.emergencyContacts, [220, 38, 38]); // Red
  doc.setFontSize(11);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(...COLORS.stone900);
  doc.text(t.emergency, margin + 5, y);
  y += 6;
  doc.text(t.police, margin + 5, y);
  y += 6;
  doc.text(t.ambulance, margin + 5, y);
  y += 15;

  // ============= USEFUL PHRASES =============
  drawSectionHeader(t.usefulPhrases, COLORS.amber);
  const phrases = [
    t.hello, t.thanks, t.please, t.sorry,
    t.howMuch, t.bill, t.delicious, t.beautiful
  ];
  phrases.forEach(phrase => addBullet(phrase));
  y += 10;

  // ============= RECOMMENDED BEACHES =============
  if (beaches.length > 0) {
    drawSectionHeader(t.beaches, COLORS.blue);
    beaches.slice(0, 5).forEach(beach => {
      if (y > pageHeight - 20) {
        doc.addPage();
        y = margin;
      }
      doc.setFontSize(10);
      doc.setFont('helvetica', 'bold');
      doc.setTextColor(...COLORS.stone900);
      doc.text(beach.name, margin + 5, y);
      y += 5;
      doc.setFontSize(8);
      doc.setFont('helvetica', 'normal');
      doc.setTextColor(...COLORS.stone600);
      const desc = beach.description || beach.type || '';
      if (desc) {
        const lines = doc.splitTextToSize(desc, pageWidth - 2 * margin - 10);
        doc.text(lines.slice(0, 2), margin + 5, y);
        y += lines.slice(0, 2).length * 4 + 4;
      }
    });
    y += 5;
  }

  // ============= UPCOMING EVENTS =============
  if (events.length > 0) {
    if (y > pageHeight - 60) {
      doc.addPage();
      y = margin;
    }
    drawSectionHeader(t.events, COLORS.teal);
    events.slice(0, 5).forEach(event => {
      if (y > pageHeight - 20) {
        doc.addPage();
        y = margin;
      }
      doc.setFontSize(10);
      doc.setFont('helvetica', 'bold');
      doc.setTextColor(...COLORS.stone900);
      doc.text(event.event_name || event.name, margin + 5, y);
      y += 5;
      doc.setFontSize(8);
      doc.setFont('helvetica', 'normal');
      doc.setTextColor(...COLORS.stone600);
      const info = `${event.town || ''} • ${event.start_date || ''}`;
      doc.text(info, margin + 5, y);
      y += 8;
    });
  }

  // ============= FOOTER =============
  const totalPages = doc.internal.getNumberOfPages();
  for (let i = 1; i <= totalPages; i++) {
    doc.setPage(i);
    doc.setFontSize(8);
    doc.setTextColor(...COLORS.stone400);
    doc.text(t.generatedBy, pageWidth / 2, pageHeight - 10, { align: 'center' });
    doc.text(`${i}/${totalPages}`, pageWidth - margin, pageHeight - 10, { align: 'right' });
  }

  // Download
  const filename = `OspitAI_PocketGuide_${location.replace(/\s+/g, '_')}.pdf`;
  doc.save(filename);
  
  return filename;
};

export default generatePocketGuide;
